// extracted by mini-css-extract-plugin
module.exports = {"root":"ProposalForm_root__2Wf3U","icon":"ProposalForm_icon__2wM65","heading":"ProposalForm_heading__zDHv-","field":"ProposalForm_field__3eVpJ","error":"ProposalForm_error__1AYJq"};